<template>
  <div class="container mt-1">
    <h2>Progetti</h2>
    <nav class="nav nav-pills nav-fill">
      <router-link :to="{ name: 'AdminProjectList' }" class="nav-item nav-link">Lista</router-link>
      <router-link :to="{ name: 'AdminProjectAdd' }" class="nav-item nav-link">Aggiungi</router-link>
    </nav>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'AdminProjectDashboard'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminProjectDashboard.vue